import { createSlice } from "@reduxjs/toolkit";
import { FilterStateDivergenceRecorded } from "./types";

const INITIAL_STATE: FilterStateDivergenceRecorded = {
  filters: {
    search: "",
    meta: {
      page: 1,
    },
  },
};

const divergenceRecordedFilterSlice = createSlice({
  name: "divergenceRecordedFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setDivergenceRecordedFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setDivergenceRecordedFilter } =
  divergenceRecordedFilterSlice.actions;
export default divergenceRecordedFilterSlice.reducer;
